import { energyAnalysisApiSlice } from '../apiSlice';

export const basicEnergyApiSlice = energyAnalysisApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBasicEnergyData: builder.query({
      query: ({
        analysisType = 'power',
        accountId,
        startTimestamp,
        endTimestamp,
        aggregateFrequency = 'month',
        unitIds = [],
        timezone,
      }) => {
        const q = new URLSearchParams();
        q.append('start_timestamp', startTimestamp);
        q.append('end_timestamp', endTimestamp);
        q.append('aggregate_frequency', aggregateFrequency);
        unitIds.length > 0
          ? unitIds.forEach((id) => q.append('unit_ids', String(id)))
          : q.append('unit_ids', '0');
        if (timezone) q.append('timezone', timezone);

        return {
          url: `/basic_energy/data/${encodeURIComponent(analysisType)}/${encodeURIComponent(String(accountId))}?${q.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['BasicEnergyData'],
    }),
    // Create a Basic Energy account / subscription
    postBasicEnergyAccount: builder.mutation({
      query: (body) => ({
        url: `/basic_energy/account`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BasicEnergySubscription'],
    }),

    // Get account by id
    getBasicEnergyAccount: builder.query({
      query: ({ account_id }) => ({
        url: `/basic_energy/account/${encodeURIComponent(String(account_id))}`,
        method: 'GET',
      }),
      providesTags: ['BasicEnergySubscription'],
    }),

    // Delete account
    deleteBasicEnergyAccount: builder.mutation({
      query: ({ account_id }) => ({
        url: `/basic_energy/account/${encodeURIComponent(String(account_id))}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BasicEnergySubscription'],
    }),

    // Get all subscriptions
    getBasicEnergySubscriptions: builder.query({
      query: () => ({
        url: `/basic_energy/subscriptions`,
        method: 'GET',
      }),
      providesTags: ['BasicEnergySubscription'],
    }),

    // Update subscription for account (patch)
    updateBasicEnergySubscription: builder.mutation({
      query: ({ account_id, body }) => ({
        url: `/basic_energy/subscription/${encodeURIComponent(String(account_id))}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['BasicEnergySubscription'],
    }),

    // Get meters for account and analysis type
    getBasicEnergyMeters: builder.query({
      query: ({ analysis_type, account_id }) => ({
        url: `/basic_energy/meters/${encodeURIComponent(analysis_type)}/${encodeURIComponent(String(account_id))}`,
        method: 'GET',
      }),
      providesTags: ['BasicEnergyMeters'],
    }),
  }),
});

export const {
  useGetBasicEnergyDataQuery,
  usePostBasicEnergyAccountMutation,
  useGetBasicEnergyAccountQuery,
  useDeleteBasicEnergyAccountMutation,
  useGetBasicEnergySubscriptionsQuery,
  useUpdateBasicEnergySubscriptionMutation,
  useGetBasicEnergyMetersQuery,
} = basicEnergyApiSlice;

export default basicEnergyApiSlice;
